import React, { useRef, useEffect, useState } from 'react';
import $ from 'jquery';
import { useDispatch } from 'react-redux';
import contriesList from 'iso-3166-1-alpha-2';
import * as R from 'ramda';
import { addServiceData, updateServiceData, deleteServiceData } from '../../../../../actions/services-api';
import ServiceData from '../../../../../constants/models/serviceData';
import { ConnectionTypes, convertConnectionTypesToServiceType } from '../../../../../constants/utils/connectionTypes';
import { PostalCityInput } from "../../../../../_common/postalCityInput";

export const ActivityDetails = ({index, activity, user, removeActivity}) => {
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
    const dispatch = useDispatch();
    
    
    const formRef = useRef(null);
    let companyName = undefined;
    let initCollapsedState = true;
    let initState = {
        type: 'Activite',
        companyName: "",
        companyAddressStreet1: "",
        companyAddressStreet2: "",
        companyAddressPostalCode: "",
        companyAddressLocality: "",
        companyAddressCountry: "FR",
        function: "",
        contractType: "CDD",
        companySavingsPlanReference: ""
    };
    if(!R.isNil(activity.id)){
        initState = activity.payload;
        initCollapsedState = false;
        companyName = activity.payload.companyName;
    }
    const [payload, setPayload] = useState(initState);
    const [collapsed, setCollapsed] = useState(initCollapsedState);

    let hasCompanySavingsPlanReference = false;
    if(!R.isNil(payload.companySavingsPlanReference) && payload.companySavingsPlanReference !== ""){
        hasCompanySavingsPlanReference = true;
    }
    const [showPee, setShowPee] = useState(hasCompanySavingsPlanReference);

    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
    }, []);

    return (
			<section className={"card card-body" + (index === 0 ? "" : " mt-4")} id={"activity" + index}>
				<div className="card-header p-0" id="headingUserDetail" role="button" onClick={() => setTimeout(() => setCollapsed(!collapsed), 200)}>
					<div className="flex-row align-items-center justify-content-lg-between" data-toggle="collapse" data-target={"#accordionActivities" + index} aria-expanded={collapsed} aria-controls="accordionActivities">
						<h4 className="h3 font-weight-black container-tight my-auto">{index === 0 ? "Votre activité principale" : "Autre activité"}</h4>
						{!R.isNil(companyName) ? (
							<span className="mr-auto align-middle">
								<i className="eva eva-arrow-right mx-2 align-middle o-30"></i>
								<span className="o-60 align-middle">{companyName}</span>
							</span>
						) : (
							""
						)}
						<button type="button" className="btn btn-icon p-0 text-uppercase font-weight-demi fs-4 my-auto ml-auto m-lg-1 o-40" name="refPrincipal">
							<i className={"eva " + (!collapsed ? "eva-arrow-ios-upward-outline" : "eva-arrow-ios-downward-outline")}></i>
						</button>
					</div>
				</div>
				<div className={"collapse" + (collapsed ? " show" : "")} id={"accordionActivities" + index} aria-labelledby="headingUserDetail" data-parent={"#activity" + index}>
					<form className="block" noValidate ref={formRef}>
						<h5 className="h4 text-uppercase text-secondary font-weight-black mb-sm mt-4">nom de l’entreprise</h5>
						<div className="row gx-2 mt-n2">
							<div className="col-12 col-md-5">
								<div className="form-group">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"companyName" + index}>
										Nom de l’entreprise
									</label>
									<input required type="text" className="form-control" id={"companyName" + index} placeholder="Entreprise" value={payload.companyName} onChange={(e) => setPayload({ ...payload, companyName: e.target.value })} />
									<div className="invalid-feedback">
										<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
										<span className="align-middle text-dark o-70">Ce champ est requis</span>
									</div>
								</div>
							</div>
							<div className="col-12 col-md-7">
								<div className="form-group">
									<div className="flex-row gx-2 align-items-center mb-1">
										<label className="h6 font-weight-bolder my-auto" htmlFor={"Adresseentreprise" + index}>
											Adresse ligne 1
										</label>
										<p
											className="form-text small text-gray my-auto ml-auto"
											data-toggle="tooltip"
											data-placement="top"
											data-html="true"
											data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
											title="L'adresse de l'organisme est nécessaire afin de pouvoir le contacter et d'effectuer les démarches.">
											<i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i>
										</p>
									</div>
									<input required type="text" className="form-control" id={"Adresseentreprise" + index} placeholder="Adresse de l'entreprise" value={payload.companyAddressStreet1} onChange={(e) => setPayload({ ...payload, companyAddressStreet1: e.target.value })} />
									<div className="invalid-feedback">
										<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
										<span className="align-middle text-dark o-70">Ce champ est requis</span>
									</div>
								</div>
								<div className="form-group">
									<label className="label h6 font-weight-bold my-auto" htmlFor={"Adresseligne2" + index}>
										Adresse ligne 2
									</label>
									<input type="text" className="form-control rounded" id={"Adresseligne2" + index} placeholder="(optionnel)" value={payload.companyAddressStreet2} onChange={(e) => setPayload({ ...payload, companyAddressStreet2: e.target.value })} />
								</div>
								<div className="form-row">
									<PostalCityInput
										postalCode={payload.companyAddressPostalCode}
										city={payload.companyAddressLocality}
										onChange={(updatedAddress) => setPayload({ ...payload, companyAddressPostalCode: updatedAddress.postalCode, companyAddressLocality: updatedAddress.city })}
										hasWrapper={false}
										country={payload.companyAddressCountry}
										customClasses={{ city: "form-group col-12 col-sm-6 col-lg", postalCode: "form-group col-12 col-sm-6 col-lg" }}
									/>
									{/* <div className="form-group col-12 col-sm-6 col-lg">
										<label className="h6 font-weight-bolder my-auto" htmlFor={"Postalentreprise" + index} required>
											Code Postal
										</label>
										<input required type="text" className="form-control" id={"Postalentreprise" + index} placeholder="ex: 75001" value={payload.companyAddressPostalCode} onChange={(e) => setPayload({ ...payload, companyAddressPostalCode: e.target.value })} />
										<div className="invalid-feedback">
											<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
											<span className="align-middle text-dark o-70">Ce champ est requis</span>
										</div>
									</div>
									<div className="form-group col-12 col-sm-6 col-lg">
										<label className="h6 font-weight-bolder my-auto" htmlFor={"Villeentreprise" + index} required>
											Ville
										</label>
										<input required type="text" className="form-control" id={"Villeentreprise" + index} placeholder="ex: Paris" value={payload.companyAddressLocality} onChange={(e) => setPayload({ ...payload, companyAddressLocality: e.target.value })} />
										<div className="invalid-feedback">
											<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
											<span className="align-middle text-dark o-70">Ce champ est requis</span>
										</div>
									</div> */}
									<div className="form-group col-12 col-sm-6 col-lg">
										<label className="h6 font-weight-bolder my-auto" htmlFor={"Paysentreprise" + index}>
											Pays
										</label>
										<select className="custom-select" id={"Paysentreprise" + index} value={payload.companyAddressCountry} onChange={(e) => setPayload({ ...payload, companyAddressCountry: e.target.value })}>
											{Object.keys(contriesList.getData()).map((country, idx) => {
												return (
													<option key={idx} value={country}>
														{countries.getName(country, "fr", { select: "official" })}
													</option>
												);
											})}
										</select>
									</div>
								</div>
							</div>
						</div>
						<hr className="mb-gutter" />
						<h5 className="h4 text-uppercase text-secondary font-weight-black mb-sm">statut professionnel</h5>
						<div className="row gx-2 mt-n2">
							<div className="col-12 col-md">
								<div className="form-group">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"poste" + index}>
										Intitulé du poste
									</label>
									<input required type="text" className="form-control" id={"poste" + index} placeholder="ex: Directeur" value={payload.function} onChange={(e) => setPayload({ ...payload, function: e.target.value })} />
									<div className="invalid-feedback">
										<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
										<span className="align-middle text-dark o-70">Ce champ est requis</span>
									</div>
								</div>
							</div>
							<div className="col-12 col-md">
								<div className="form-group">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"contrat" + index}>
										Type du contrat
									</label>
									<select className="custom-select" id={"contrat" + index} value={payload.contractType} onChange={(e) => setPayload({ ...payload, contractType: e.target.value })}>
										<option value="CDD">CDD</option>
										<option value="CDI">CDI</option>
										<option value="Trial">Autre</option>
									</select>
								</div>
							</div>
						</div>
						<hr className="mb-gutter" />
						<div className="grid grid-md-2 align-items-center mb-sm">
							<h5 className="h4 text-uppercase text-secondary font-weight-black">Plan d'épargne entreprise</h5>
							<div className="grid grid-2 ml-auto align-items-center">
								<button type="button" className="btn btn-icon p-1 align-middle o-0 mx-auto" onClick={() => setShowPee(!showPee)}>
									<i className="eva eva-edit-2-outline align-middle fs-lead"></i>
								</button>
								<div className="custom-control custom-switch mx-auto">
									<input type="checkbox" className="custom-control-input" id={"showPeeInput" + index} onChange={() => setShowPee(!showPee)} />
									<label className="custom-control-label" htmlFor={"showPeeInput" + index}>
										{showPee ? "Oui" : "Non"}
									</label>
								</div>
							</div>
						</div>
						{showPee ? (
							<div className="row gx-2 mt-n2">
								<div className="col-12 col-md">
									<div className="form-group">
										<div className="flex-row gx-2 align-items-center mb-1">
											<label className="h6 font-weight-bolder my-auto" htmlFor={"reference" + index}>
												Référence
											</label>
											<p
												className="form-text small text-gray my-auto ml-auto"
												data-toggle="tooltip"
												data-placement="top"
												data-html="true"
												data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
												title="Une référence permet à vos organismes de vous identifier afin de faire les démarches nécessaires.">
												<i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i>
											</p>
										</div>
										<input type="text" className="form-control" id={"companySavingsPlanInput" + index} value={payload.companySavingsPlanReference} onChange={(e) => setPayload({ ...payload, companySavingsPlanReference: e.target.value })} />
										<div className="invalid-feedback">
											<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
											<span className="align-middle text-dark o-70">Ce champ est requis</span>
										</div>
									</div>
								</div>
							</div>
						) : (
							""
						)}

						<hr className="my-0" />
						<div className="card-footer text-right px-0">
							<button
								className="btn btn-sm btn-alert-info border-none loading-btn"
								onClick={(e) => {
									e.preventDefault();
									if (formRef.current.checkValidity()) {
										let serviceData = new ServiceData({ userId: user.user.id, serviceType: convertConnectionTypesToServiceType(ConnectionTypes.activity), serviceId: "activite" + index, payload: payload });
										if (R.isNil(activity.id)) {
											dispatch(addServiceData(serviceData));
										} else {
											serviceData.id = activity.id;
											dispatch(updateServiceData(serviceData));
										}
										setCollapsed(!collapsed);
									}
									formRef.current.classList.add("was-validated");
								}}>
								enregistrer
								<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
							</button>
							{index === 0 ? (
								""
							) : (
								<span
									className="btn btn-sm btn-icon px-xs btn-alert-danger ml-1 border-none"
									id="basic-addon2"
									onClick={(e) => {
										e.preventDefault();
										if (R.isNil(activity.id)) {
											removeActivity(activity);
										} else {
											dispatch(deleteServiceData(activity.id, ConnectionTypes.activity));
										}
									}}>
									<i className="eva eva-trash-outline"></i>
								</span>
							)}
						</div>
					</form>
				</div>
			</section>
		);
}